import { API_STATES } from "@/helpers";
const state = {
  positionsGetState       : API_STATES.NOT_REQUESTED,
  positionsGetError       : null,
  positionDeleteState     : API_STATES.NOT_REQUESTED,
  positionDeleteError     : null,
  positionCreateState     : API_STATES.NOT_REQUESTED,
  positionCreateError     : null,
  positions               : [],
  positionUpdateState     : API_STATES.NOT_REQUESTED,
  positionUpdateError     : null,
  userPositionUpdating    : [],
  userPositionUpdateError : null,
  userPositionDeleting    : [],
  userPositionDeleteError : null,
  userPositions           : [],
  position                : {}
};

export default state;
